var $ = jQuery;
$(document).ready(function ($) {
    const menu = $('.header-links');
    const overlay = $('.header-overlay');
    const btnClose = $('.header-openBtn_close');

    function menuItemToggle() {
        const item = $('#menu-menu > .menu-item-has-children > a');

        item.click(function (e) {
            e.preventDefault();
            e.stopPropagation();
            let subMenu = $(this).next('.sub-menu').eq(0)
            subMenu.stop().toggleClass('opened')
        })
    }

    function menuOpen() {
        let menuBtn = $('#menu');

        menuBtn.click(function () {
            menu.addClass('opened');
            overlay.addClass('opened');
            btnClose.css('display', 'block');
            $('body').addClass('overflow-hidden');
        })
    }

    function menuClose() {

        $('#close').click(function () {
            menu.removeClass('opened');
            overlay.removeClass('opened');
            btnClose.css('display', 'none');
            $('body').removeClass('overflow-hidden')
        })

        $('.menu-item:not(.menu-item-has-children) a').on('click', function(){
            $('.header-mobileMenu').removeClass('opened');
            $('.header-openBtn_close').toggle();
            $('body').removeClass('overflow-hidden')
        })
    }


    function faqAccorion() {
        $('.faq-title').click(function () {
            $(this).find('.faq-sign').toggleClass('opened');
            $(this).next('.faq-descr').stop().slideToggle('fast')
        })
    }

    function video_play() {
        const video = $('.banner-video video');
        if(!!video.length) {
            $('.banner-video video').get(0).play();
        }
    }

    video_play();
    menuOpen();
    menuClose();
    menuItemToggle();
    faqAccorion(); 
})